import {
    onRetentionTagForItemsChanged,
    onRetentionTagForItemsUpdateSuccess,
} from '../actions/internalActions';
import setItemRetentionPolicy from '../services/setItemRetentionPolicy';
import {
    ARCHIVE_INHERIT_SUBMENU_ITEM_IDENTIFIER,
    DELETE_INHERIT_SUBMENU_ITEM_IDENTIFIER,
} from '../utils/retentionPolicyConstants';
import { orchestrator } from 'satcheljs';
import * as trace from 'owa-trace';
import logRetentionPolicySelected from '../utils/logging';

/**
 * Responsible for updating the item's retention tag by service call and then at client if call is successful
 */
export default orchestrator(onRetentionTagForItemsChanged, async actionMessage => {
    try {
        const { isArchiveTag, tagValue, itemIds, actionSource, mailboxInfo } = actionMessage;
        const tag =
            tagValue === ARCHIVE_INHERIT_SUBMENU_ITEM_IDENTIFIER ||
            tagValue === DELETE_INHERIT_SUBMENU_ITEM_IDENTIFIER
                ? null
                : {
                      Value: tagValue,
                      IsExplicit: true,
                  };
        const response = await setItemRetentionPolicy(
            itemIds,
            isArchiveTag,
            tag,
            mailboxInfo.requestOptions
        );

        if (response.ResponseClass == 'Success') {
            onRetentionTagForItemsUpdateSuccess(tag, isArchiveTag, itemIds);
        }
        logRetentionPolicySelected({
            isArchiveTag: isArchiveTag,
            actionSource: actionSource,
            responseClass: response.ResponseClass,
        });
    } catch (e) {
        trace.errorThatWillCauseAlert('Error while updating item retention tag ' + e);
    }
});
